import { CREHANA_LEGAL_PAGE_KEY } from '@/views/CrehanaLegal/constants';

const pt = {
  [CREHANA_LEGAL_PAGE_KEY]: {
    MENU_TITLE: 'Contenido',
    UPDATED_AT: 'Fecha de última actualización:',
    GO_BACK: 'Regresar',
    TERMS_AND_CONDITIONS_TITLE: 'Términos y condiciones',
    TERMS_AND_CONDITIONS_B2B_TITLE: 'Términos y condiciones B2B',
    TERMS_AND_CONDITIONS_B2B_EN_TITLE: 'Terms and conditions B2B',
    TERMS_AND_CONDITIONS_B2B_BR_TITLE: 'Términos y condiciones B2B (Brasil)',
    PRIVACY_TITLE: 'Políticas de privacidad y protección de datos personales',
    PRIVACY_BR_TITLE: 'Política de privacidade (Brasil)',
    PRIVACY_PE_LABEL: 'Perú',
    PRIVACY_CO_LABEL: 'Colombia',
    PRIVACY_CL_LABEL: 'Chile',
    PRIVACY_MX_LABEL: 'México',
    PRIVACY_NOTICE_MX_TITLE: 'Avisos de privacidad (México)',
    PRIVACY_NOTICE_CO_TITLE: 'Avisos de privacidad (Colombia)',
    MEMBERSHIP_POLICY_TITLE: 'Políticas de Membresías',
    MEMBERSHIP_POLICY_PREMIUM_LABEL: 'Premium individual',
    MEMBERSHIP_POLICY_DUO_LABEL: 'Premium Dúo',
    MEMBERSHIP_POLICY_FAMILY_LABEL: 'Premium Familiar',
    MEMBERSHIP_POLICY_STUDENT_LABEL: 'Estudiantil',
    PAYG_POLICY_TITLE: 'Políticas de Pay As You Go',
    TEACHER_AGREEMENT_TITLE: 'Acuerdo para profesores',
    COOKIES_POLICY_TITLE: 'Política de cookies',
    ARCO_TITLE: 'Solicitud ARCO',
    REFUND_POLICY_TITLE: 'Politicas de reembolso',
    SECURITY_AND_PRIVACY_POLICY_TITLE:
      'Política general de seguridad y privacidad de la información',
    SLA_TITLE: 'Service Level Agreement (SLA)',
  },
};

export default pt;
